export const MESSAGES = {
  DELETE_ERROR: 'Failed to delete the document. Please try again.',
  DOWNLOAD_ERROR: 'Failed to get download link. Please try again.',
  UPLOAD_DOCUMENT_TITLE: 'Upload document'
}
